import { render, staticRenderFns } from "./AccountInputTerritories.vue?vue&type=template&id=3dbc82a8"
import script from "./AccountInputTerritories.vue?vue&type=script&lang=js"
export * from "./AccountInputTerritories.vue?vue&type=script&lang=js"
import style0 from "./AccountInputTerritories.vue?vue&type=style&index=0&id=3dbc82a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports